import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  
    
    <div class="imagen">
    <div class="texto">
    <span class="created-by"><b><a href="https://www.sedic.es/" target="_blank">SEDIC - Actividades y gestión de socios </a></b></span>
    <span class="created-by"><b><a  style="color:#FF9999" href="/#/public/avisoLegal" target="_blank"> - Política de privacidad y aviso legal</a></b></span>

    </div>
    <p></p>
    Es recomendable usar el navegador Google Chrome.
    <p></p>
    <p></p>
    Esta intranet de SEDIC fue desarrollada con la colaboración de:
    <p></p>
    <img src="../../../../assets/images/GobWeb.jpg" alt="GobWeb" style="max-width: 12em;">
    <p></p><p></p>
    <span style="font-size:10px"> © 2024 - Todos los derechos reservados</span>
    </div>
    <!--<div class="socials">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>-->
  `,
})
export class FooterComponent {
}
